var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131.844,
    height: 131.845,
    viewBox: "0 0 131.844 131.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "test_1_",
    "data-name": "test (1)",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589",
    transform: "translate(4.131 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M143.756,65.922a65.686,65.686,0,0,1-17.419,44.645c-12.047,13.081-29.584,17.155-48.77,17.155-36.408,0-61.525-26.746-61.525-63.153,0-27.992,13.315-50.556,37.927-60.117a65.964,65.964,0,0,1,89.786,61.47Z",
    transform: "translate(-16.043 0)",
    fill: "#4e6fd8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590",
    transform: "translate(0 4.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M432.474,100.258l-4.464-9.075a1.387,1.387,0,0,0-2.49,0l-4.6,9.366.01,67.555h9.332a2.369,2.369,0,0,0,2.368-2.369l-.01-64.863a1.386,1.386,0,0,0-.142-.612Z",
    transform: "translate(-312.526 -71.555)",
    fill: "#3448ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M98.4,110.409V50.08a6.778,6.778,0,0,0-1.981-4.788L76.876,25.715a6.778,6.778,0,0,0-4.8-1.99H44.941a3.868,3.868,0,0,1-2.868-6.468l.057-.062a65.928,65.928,0,1,0,72.292,106.137l-.152.059A11.714,11.714,0,0,1,98.4,112.423v-2.014Z",
    transform: "translate(0 -17.195)",
    fill: "#3448ca"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_591",
    "data-name": "Group 591",
    transform: "translate(102.509 25.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M409.775,146.9h5.808v67.555h-5.808Z",
    transform: "translate(-406.763 -135)",
    fill: "#fee135"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M431.056,214.449h3.23l-.01-67.554h-3.22Z",
    transform: "translate(-422.564 -134.998)",
    fill: "#faf58c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M0,0H67.555V3.405H0Z",
    transform: "translate(3.405 11.887) rotate(90)",
    fill: "#ffc305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M398.123,112.595l11.7,0-5.852-11.9Z",
    transform: "translate(-398.112 -100.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M416.72,105.143l-2.187-4.446-2.185,4.446Z",
    transform: "translate(-408.673 -100.697)",
    fill: "#2d56a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M413.41,105.143l1.122-4.446-2.185,4.446Z",
    transform: "translate(-408.673 -100.697)",
    fill: "#1a396b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_593",
    "data-name": "Group 593",
    transform: "translate(10.171 15.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M224.667,148.2V83.214L201.159,59.663H177.967V148.2Z",
    transform: "translate(-142.31 -59.663)",
    fill: "#c4e6eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M291.583,83.214H268.032V59.663Z",
    transform: "translate(-209.183 -59.663)",
    fill: "#fee135"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M76.364,142.94a3.407,3.407,0,0,1,3.407-3.407h33.545v-5.822H79.771a3.407,3.407,0,0,1-3.407-3.407v-1.01a3.407,3.407,0,0,1,3.407-3.407h33.545v-5.822H79.771a3.407,3.407,0,0,1-3.407-3.407v-1.01a3.407,3.407,0,0,1,3.407-3.407h33.545v-5.822H79.771a3.407,3.407,0,0,1-3.407-3.407V102a3.407,3.407,0,0,1,3.407-3.407h33.545V92.772H76.364V59.663H39.5V163.181h82.356V146.347H79.771A3.407,3.407,0,0,1,76.364,142.94Z",
    transform: "translate(-39.499 -59.663)",
    fill: "#7dc5d0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592",
    transform: "translate(33.283 30.796)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M168.751,179.255h40.534v5.822H168.751Z",
    transform: "translate(-168.751 -179.255)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M168.751,232.249h40.534v5.822H168.751Z",
    transform: "translate(-168.751 -218.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M168.751,285.243h40.534v5.822H168.751Z",
    transform: "translate(-168.751 -257.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M168.751,338.236h40.534v5.822H168.751Z",
    transform: "translate(-168.751 -297.297)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M68.566,137.19H87.161v18.595H68.566Z",
    transform: "translate(-61.081 -117.226)",
    fill: "#e20a62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M68.566,237.108H87.161V255.7H68.566Z",
    transform: "translate(-61.081 -191.414)",
    fill: "#fe9535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M68.566,337.026H87.161v18.595H68.566Z",
    transform: "translate(-61.081 -265.603)",
    fill: "#0e7f8a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSat);
export default __webpack_public_path__ + "static/media/sat.16d3e5bb9a006fed887e276375fa2581.svg";
export { ForwardRef as ReactComponent };